export default __webpack_public_path__ + "assets/margin-onboarding-2-743a05d3cab310a36079d336e16ba62b.png";